import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceFiscalAssessmentDocumentGroupsUpdateDocumentsDeleteProps {
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    {
      documentGroupId: string;
      documentId: string;
    }
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceFiscalAssessmentDocumentGroupsUpdateDocumentsDelete = ({
  options,
}: UseMaintenanceFiscalAssessmentDocumentGroupsUpdateDocumentsDeleteProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceFiscalAssessmentDocumentGroupsUpdateDocumentsDelete'],
    mutationFn: ({ documentGroupId, documentId }) => {
      const payload = {
        documents_attributes: [
          {
            id: documentId,
            _destroy: true,
          },
        ],
      }

      return privateAxios.put(`/maintenance/fiscal_assessment_document_groups/${documentGroupId}/update_documents`, payload);
    },
    ...options
  });
}
